// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  engineApiV2,
  EngineTagTypes,
} from '@shared/data-access/api-base/citec-engine-api';
import {
  type ClientOnboardingStateResponse,
  type UpdateClientOnboardingProfileRequestBody,
} from '@shared/data-access/types/engine';

export const onboardingApi = engineApiV2.injectEndpoints({
  endpoints: build => ({
    getClientOnboardingState: build.query<ClientOnboardingStateResponse, void>({
      queryFn: async (_params, _api, _extraOptions, fetchWithBQ) => {
        const result = await fetchWithBQ({
          url: '/onboarding/',
          method: 'GET',
        });

        if (result.error) {
          return { error: result.error as FetchBaseQueryError };
        }

        return { data: result.data as ClientOnboardingStateResponse };
      },
      providesTags: [{ type: EngineTagTypes.Onboarding, id: 'STATE' }],
    }),

    updateClientOnboardingProfile: build.mutation<
      void,
      UpdateClientOnboardingProfileRequestBody
    >({
      queryFn: async (params, _api, _extraOptions, fetchWithBQ) => {
        const result = await fetchWithBQ({
          url: '/onboarding/',
          method: 'PATCH',
          body: params,
        });

        if (result.error) {
          return { error: result.error as FetchBaseQueryError };
        }

        return { data: result.data as void };
      },
      invalidatesTags: (_result, error) => {
        if (error) {
          return [];
        }

        return [{ type: EngineTagTypes.Onboarding, id: 'STATE' }];
      },
    }),
  }),
});
